import React from 'react';
import {Switch} from "antd";

const CustomSwitch = (props) => {
    const { isChecked, onToggle, ...rest } = props;
    return (
        <Switch checked={isChecked} onChange={onToggle} size="small" {...rest}/>
    );
};

export default CustomSwitch;
